// extracted by mini-css-extract-plugin
export default {"FilledButton":"FilledButton_FilledButton__VKNz5"};